"use strict";
'use client';

/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Experimental__IconGooglePlus = Experimental__IconGooglePlus;
exports.IconGooglePlus = IconGooglePlus;
var _react = _interopRequireDefault(require("react"));
var _index = require("../../index.js");
/**
 * @deprecated IconGooglePlus is deprecated and will be archived soon. To find a suitable alternative, refer to https://encore.spotify.net/foundation/basics/icons?format=web-js#browse-icons.
 */
function IconGooglePlus(props) {
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'M5.09 9.106V7.36h4.813c.013.099.025.186.037.263.013.078.022.167.027.268.006.102.01.208.01.319 0 .96-.202 1.818-.606 2.572a4.343 4.343 0 01-1.718 1.765c-.742.422-1.596.633-2.563.633a4.936 4.936 0 01-3.261-1.182A4.992 4.992 0 010 8.09c0-.69.134-1.349.402-1.978.267-.628.63-1.17 1.086-1.624a5.086 5.086 0 011.626-1.086A4.993 4.993 0 015.09 3c1.324 0 2.46.443 3.41 1.33L7.121 5.66c-.547-.523-1.225-.785-2.032-.785-.425 0-.833.085-1.224.254-.392.17-.729.397-1.012.684a3.192 3.192 0 00-.674 1.025 3.3 3.3 0 00-.166 1.992c.056.24.135.465.24.674.104.209.23.407.374.595.145.188.308.354.49.5.181.144.377.27.587.378.21.108.431.19.665.244a3.417 3.417 0 001.779-.073 2.68 2.68 0 00.798-.397c.21-.16.39-.343.544-.546a2.43 2.43 0 00.338-.577 2.99 2.99 0 00.152-.522H5.09zM16 8.82V7.36h-1.45V5.91h-1.46v1.45h-1.45v1.46h1.45v1.45h1.46V8.82H16z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'M8.363 13.633V11.45h6.016c.015.123.03.233.046.33.016.096.027.208.034.334.008.127.011.26.011.398 0 1.201-.252 2.273-.756 3.216a5.43 5.43 0 01-2.148 2.206c-.927.527-1.995.791-3.203.791-1.54 0-2.899-.493-4.077-1.478a6.24 6.24 0 01-2.148-3.521A6.723 6.723 0 012 12.363c0-.863.167-1.687.502-2.472a6.34 6.34 0 011.357-2.032 6.357 6.357 0 012.033-1.357A6.24 6.24 0 018.362 6c1.655 0 3.076.554 4.262 1.663l-1.721 1.663c-.685-.655-1.532-.982-2.54-.982-.532 0-1.042.106-1.531.317-.489.212-.91.497-1.264.856a3.99 3.99 0 00-.843 1.28 4.125 4.125 0 00-.208 2.49c.07.3.17.582.3.843.13.261.287.51.468.744.18.235.384.443.611.624.228.18.473.338.735.473.262.135.539.237.83.305.294.07.594.105.902.105.477 0 .918-.065 1.322-.196a3.33 3.33 0 00.998-.496c.262-.201.49-.429.681-.683.193-.254.334-.494.422-.721a3.66 3.66 0 00.19-.652H8.364zM22 13.275V11.45h-1.813V9.637h-1.824v1.813H16.55v1.825h1.813v1.813h1.824v-1.813H22z\'/>'
  }];
  var closestSize = (0, _index.findClosestGlyphAvailable)(iconList, props.iconSize || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = props.autoMirror || false;
  return /*#__PURE__*/_react["default"].createElement(_index.Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}

/**
 * @deprecated IconGooglePlus is deprecated and will be archived soon. To find a suitable alternative, refer to https://encore.spotify.net/foundation/basics/icons?format=web-js#browse-icons.
 */
function Experimental__IconGooglePlus(props) {
  return /*#__PURE__*/_react["default"].createElement(IconGooglePlus, props);
}